@if (defects().length > 0) {
  <span class="defect-ref-chips" role="group" [attr.aria-label]="'defect.ref.groupLabel' | translate">
    @for (d of defects(); track d.id) {
      <a
        class="defect-ref-chips__chip"
        data-testid="defect-chip"
        [class.defect-ref-chips__chip--blocking]="d.blocking"
        [attr.data-blocking]="d.blocking"
        [routerLink]="['/projects', projectId(), 'defects', d.id]"
        [matTooltip]="
          d.blocking
            ? ('defect.ref.blockingTitle' | translate)
            : ('defect.ref.statusTitle' | translate: { key: d.key, status: ('defect.status.' + d.status | translate) })
        "
        [attr.aria-label]="(d.blocking ? 'defect.ref.openBlocking' : 'defect.ref.open') | translate: { key: d.key }"
      >
        <app-icon name="bug" [size]="12" />
        @if (compact()) {
          <span class="sr-only">{{ ('defect.ref.label' | translate) + ' ' }}</span>
        } @else {
          {{ 'defect.ref.label' | translate }}
        }
        <span class="defect-ref-chips__key" data-testid="defect-key">{{ d.key }}</span>
      </a>
    }
  </span>
}
